<template>
    <div class="mt-1" >
        <h4 class="headline text-xs-center">Item Class Show / Hide</h4>
        <v-layout row v-if="error">
            <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>  
        <v-layout row>
            <v-flex xs12>
                <v-data-table
                    v-bind:headers="headers"
                    :items="itemClasses"
                    hide-actions
                    class="elevation-1"
                    >
                    <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td class="text-xs-right">
                        <v-btn small @click.prevent="onShowHideClass(props.item.id)">{{ props.item.hideFromWebQuote ? "Show All Items of This Class" : "Hide All Items of This Class"}}</v-btn>
                    </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    data: () => ({
        itemClasses: [],
        headers: [
          {
            text: 'Item Class',
            align: 'left',
            sortable: true,
            value: 'name'
          },
          { text: 'Show / Hide', align: 'middle', sortable: false }
        ]
    }),
    computed: {
        // userIsAuthenticated () {
        //     return this.$store.getters.userIsAuthenticated
        // },
        // user () {
        //     return this.$store.getters.user
        // },
        error () {
            return this.$store.getters.error
        },
        // loading () {
        //     return this.$store.getters.loading
        // }
    },
    watch: {
        // userIsAuthenticated (value) {
        //     if (!value) {
        //         this.$router.push('/')
        //     }
        // }
    },
    methods: {
        ...mapActions('adminItemClass', [
            'getItemClasses',
            'showHideItemClassInWebQuote',
        ]),
        async loadClasses () {
            const result = await this.getItemClasses()
            if (typeof result === 'string') {
                alert(result)
            } else {
                this.itemClasses = result
            }
        },
        async onShowHideClass (id) {
            const result = await this.showHideItemClassInWebQuote(id)
            if (result === 'successful') {
                this.loadClasses()
            } else {
                alert(result)
            }
        },
        onDismissed () {
            // console.log('onDismissed alert')
            // this.$store.dispatch('clearError')
        }
    },
    created: function () {
        // if (!this.$store.getters.userIsAuthenticated) {
        //     this.$router.push('/')
        // }
        this.loadClasses()
    },
    destroyed: function () {
        this.onDismissed()
    }
}
</script>